import { createRoot } from 'react-dom/client';
import { App } from './App';
import { CloudGate } from './cloud/CloudGate';
import { engineRequest, isDevice, requestSync, syncAndWait } from './engine/client';
import './styles.css';

if (isDevice) {
  // 기기 모드: 엔진은 CloudGate 가 (클라우드면 로그인·열쇠 준비 뒤에) 띄운다. 화면을 볼 때·연결이 돌아올 때·2분마다 동기화
  window.setInterval(() => {
    if (document.visibilityState === 'visible') requestSync();
  }, 120_000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') requestSync();
  });
  window.addEventListener('online', () => requestSync());
  (window as unknown as { apexEngine: unknown }).apexEngine = { request: engineRequest, sync: requestSync, syncAndWait }; // 시험·점검용
}

createRoot(document.getElementById('root') as HTMLElement).render(isDevice ? <CloudGate><App /></CloudGate> : <App />);

// 서비스 워커: 인터넷 없이도 화면이 열리게 (localhost 또는 HTTPS 에서만 동작)
if ('serviceWorker' in navigator && window.isSecureContext) {
  let hadController = Boolean(navigator.serviceWorker.controller);
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) location.reload(); // 새 빌드가 활성화되면 한 번 새로고침
    hadController = true;
  });
  void navigator.serviceWorker.register('./sw.js').catch(() => undefined);
}
